import { render, staticRenderFns } from "./ExchangeGoods.vue?vue&type=template&id=38cb1b61&scoped=true"
import script from "./ExchangeGoods.vue?vue&type=script&lang=js"
export * from "./ExchangeGoods.vue?vue&type=script&lang=js"
import style0 from "./ExchangeGoods.vue?vue&type=style&index=0&id=38cb1b61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cb1b61",
  null
  
)

export default component.exports